import React from 'react';
import '../css/Footer.css';

import logo from '../img/logos/escudo.png';

import facebookIcon from '../img/logos/facebookcircle.png';
import twitterIcon from '../img/logos/twittercircle.png';
import instagramIcon from '../img/logos/instagramcircle.png';
import youtubeicono from '../img/logos/youtubeicono.png';

function Footer() {

    return (

        <footer className="esc-footer">

            <div className="esc-footer-contenido">

                {/* Logo */}

                <div className="esc-footer-logo">

                    <img
                        src={logo}
                        alt="Escuela Nueva Zelandia"
                    />

                </div>


                {/* Datos */}

                <div className="esc-footer-contacto">

                    <h3>Escuela Nueva Zelandia</h3>

                    <p>📍 Gamero 2722, Independencia</p>

                    <p>☎ +56 2 2710 3043</p>

                    <p>✉ escuela@nzelandia.cl</p>

                </div>


                {/* Redes */}

                <div className="esc-footer-redes">

                    <h3>Nuestras Redes Sociales</h3>

                    <div className="esc-footer-iconos">

                        <a
                            href="https://www.facebook.com/EscuelaNuevaZelancia"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={facebookIcon}
                                alt="Facebook"
                            />
                        </a>

                        <a
                            href="https://twitter.com/zelandia_nueva?lang=bg/"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={twitterIcon}
                                alt="X"
                            />
                        </a>

                        <a
                            href="https://www.instagram.com/nuevazelandiaescuela"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={instagramIcon}
                                alt="Instagram"
                            />
                        </a>

                        <a
                            href="https://www.youtube.com/channel/UCv9kvVQXl1zXASkSQfra55w"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={youtubeicono}
                                alt="YouTube"
                            />
                        </a>

                    </div>

                </div>

            </div>


            <div className="esc-footer-copy">

                © 2026 Escuela Nueva Zelandia · Todos los derechos reservados.

            </div>

        </footer>

    );

}

export default Footer;